export default {
  orgSettings: [],
  orgSetting: undefined,
};
